import { Modal, Form, Button } from 'react-bootstrap';
import React, { useState } from 'react';
import Required from '../Required';
import DraggableModal from '../UI/DraggableModal';

export default function SendForRevisionModal({ show, onSubmit, onClose }) {
  const [comment, setComment] = useState(undefined);

  const handleClose = () => {
    setComment(undefined);
    onClose();
  };

  const handleSubmit = async () => {
    if (comment) {
      await onSubmit(comment);
      handleClose();
    }
  };

  return (
    <DraggableModal show={show} headerNode='Возврат на доработку' onHide={handleClose}>
      <Modal.Body>
        <Form.Group md="12">
          <Form.Label>
            Комментарий
            <Required />
          </Form.Label>
          <br />
          <Form.Control
            as="textarea"
            rows={3}
            value={comment}
            onChange={({ target }) => setComment(target.value)}
            placeholder="Введите рекомендации"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose} variant="outline-secondary">Отмена</Button>
        <Button disabled={!comment} onClick={handleSubmit} variant="outline-primary">ОК</Button>
      </Modal.Footer>
    </DraggableModal>
  );
}
